import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { REPORT_LABEL_BY_SLUG } from './reportRouteMeta';

/** Placeholder for report routes that are not implemented in this app yet. */
export default function ReportPlaceholder() {
  const { reportKey } = useParams();
  const title = reportKey ? REPORT_LABEL_BY_SLUG[reportKey] : null;

  if (!title) {
    return <Navigate to="/home" replace />;
  }

  return (
    <div className="max-w-3xl space-y-4">
      <h2 className="page-title text-2xl font-semibold text-gray-900">{title}</h2>
      <p className="text-sm text-gray-600 leading-relaxed">This report is not available in the React app yet.</p>
    </div>
  );
}
